import React from "react";
import { Link } from "react-router-dom";
import { server_ip } from "../../Utils/Data";

const resolveImageUrl = (src) => {
    if (!src) return "assets/img/project/project-1-1.jpg";
    if (src.startsWith("http://") || src.startsWith("https://") || src.startsWith("data:")) {
        return src;
    }
    const normalized = src.startsWith("/") ? src : `/${src}`;
    return `${server_ip}${normalized}`;
};

const Project = ({ data }) => {
    return (
        <>
            {data.length > 0 ? (
                data.map((object, index) => (
                    <div
                        className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp"
                        key={index}
                        data-wow-delay=".3s"
                        style={{
                            visibility: "visible",
                            animationDelay: "0.3s",
                            animationName: "fadeInUp",
                        }}
                    >
                        <Link
                            to={{
                                pathname: `/project-details`,
                            }}
                            state={{object}}
                            className="text-decoration-none"
                        >
                            <div className="project-one__single position-relative" style={{cursor: 'pointer'}}>
                                <div
                                    className="project-one__img-box"
                                    style={{
                                        aspectRatio: "1 / 1",
                                        backgroundColor: "#f9f9f9",
                                        overflow: "hidden",
                                        borderRadius: "8px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        position: "relative",
                                    }}
                                >
                                    <div className="project-one__img">
                                        <img
                                            src={resolveImageUrl(object.image1 || object.image || object.logo || object.thumbnail)}
                                            alt={object.title || "Project"}
                                            style={{
                                                maxWidth: "100%",
                                                maxHeight: "100%",
                                                objectFit: "contain",
                                            }}
                                        />
                                    </div>

                                    {/* Hover Title Overlay */}
                                    <div
                                        className="project-hover-title"
                                        style={{
                                            position: "absolute",
                                            bottom: "0",
                                            left: "0",
                                            right: "0",
                                            background: "rgba(0,0,0,0.6)",
                                            color: "#fff",
                                            textAlign: "center",
                                            padding: "10px",
                                            opacity: "0",
                                            transition: "opacity 0.3s",
                                            fontWeight: "bold",
                                            fontSize: "1rem",
                                            borderBottomLeftRadius: "8px",
                                            borderBottomRightRadius: "8px",
                                        }}
                                    >
                                        {object.title}
                                    </div>
                                </div>
                            <div style={{fontSize:"20px"}} className="mt-2 text-center text-uppercase fw-bold">
                                {object.title}
                            </div>
                            </div>

                        </Link>
                    </div>
                ))
            ) : (
                <div className="text-danger mx-auto text-center">
                    <span className="fw-bolder">NO PROJECTS AVAILABLE</span>
                </div>
            )}
        </>
    );
};

export default Project;
